export function h(TagOrElement, props) {
    if (props === void 0) { props = {}; }
    var childNodes = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        childNodes[_i - 2] = arguments[_i];
    }
    var element = typeof TagOrElement === 'string'
        ? document.createElement(TagOrElement)
        : new TagOrElement();
    if (props === null) {
        props = {};
    }
    var setProperty = function (key, value) {
        if (key == null) {
            return;
        }
        if (typeof value === 'function') {
            element[key] = value;
        }
        else {
            element.setAttribute(key, value == null ? '' : value.toString());
        }
    };
    for (var _a = 0, _b = Object.keys(props); _a < _b.length; _a++) {
        var key = _b[_a];
        setProperty(key, props[key]);
    }
    var appendChild = function (node) {
        if (node instanceof Node) {
            element.appendChild(node);
        }
        else if (node instanceof NodeList || node instanceof HTMLCollection) {
            for (var _i = 0, _a = Array.prototype.slice.call(node); _i < _a.length; _i++) {
                var n = _a[_i];
                element.appendChild(n);
            }
        }
        else {
            element.appendChild(document.createTextNode(String(node)));
        }
    };
    for (var _c = 0, _d = childNodes.filter(function (x) { return x != null; }); _c < _d.length; _c++) {
        var node = _d[_c];
        if (Array.isArray(node)) {
            for (var _e = 0, node_1 = node; _e < node_1.length; _e++) {
                var n = node_1[_e];
                appendChild(n);
            }
        }
        else {
            appendChild(node);
        }
    }
    return element;
}
//# sourceMappingURL=index.js.map
